module.exports = __webpack_public_path__ + "static/media/MTL_BASE_SYNTH3.ef725ad0.png";